import { render, staticRenderFns } from "./busComponent.vue?vue&type=template&id=6469ec5a&scoped=true&"
import script from "./busComponent.vue?vue&type=script&lang=js&"
export * from "./busComponent.vue?vue&type=script&lang=js&"
import style0 from "./busComponent.vue?vue&type=style&index=0&id=6469ec5a&scoped=true&lang=css&"
import style1 from "./busComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6469ec5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VChip,VChipGroup,VTooltip})
